import React from 'react';
import './Cards.css'
import {
    Card, CardText, CardBody,
    CardTitle,
  } from 'reactstrap';

import {Link} from 'react-router-dom'

  const Cards = (props) => {
    return (
            <Card className="cardService mb-3"> 
                <CardTitle className="h3 mt-3" style={{color:'#154360'}}>{props.title}</CardTitle>
                <CardBody>
                  <Link to={"more-info/"+props.id} ><img width="100%" src={props.imgsrc} alt="serviceImg" /></Link>
                  <hr/>
                  <CardText>{props.content}</CardText>
                   {/* <Link to={props.path} >Read more</Link>  */}
                  <Link to={"more-info/"+props.id} >Read more</Link>
                  
                </CardBody>
            </Card>
    );
  };
  
  export default Cards;